import type { CoreLocation } from '@/lib/zifekCore';

interface Props {
  locations: CoreLocation[];
}

export default function LocationsPanel({ locations }: Props) {
  if (locations.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-background-50 border border-background-200/70 rounded-lg">
        <div className="w-14 h-14 rounded-full bg-background-100 flex items-center justify-center mb-3">
          <i className="ri-store-2-line text-2xl text-foreground-400"></i>
        </div>
        <p className="text-foreground-600">Aucun établissement.</p>
      </div>
    );
  }

  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="bg-background-100 text-left text-xs text-foreground-500">
              <th className="px-4 py-3 font-medium">Établissement</th>
              <th className="px-4 py-3 font-medium">Organisation</th>
              <th className="px-4 py-3 font-medium">Adresse</th>
              <th className="px-4 py-3 font-medium">Téléphone</th>
              <th className="px-4 py-3 font-medium">Statut</th>
            </tr>
          </thead>
          <tbody>
            {locations.map((l) => (
              <tr key={l.id} className="border-t border-background-200/60">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2 min-w-0">
                    <span className="font-medium text-foreground-900 truncate">{l.name}</span>
                    {l.is_primary && (
                      <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 font-medium whitespace-nowrap">
                        Principal
                      </span>
                    )}
                  </div>
                </td>
                <td className="px-4 py-3 text-foreground-600">
                  {l.core_organizations?.commercial_name || `Org #${l.organization_id ?? '—'}`}
                </td>
                <td className="px-4 py-3 text-foreground-600">
                  {[l.core_addresses?.address_line_1, l.core_addresses?.city, l.core_addresses?.country]
                    .filter(Boolean)
                    .join(', ') || '—'}
                </td>
                <td className="px-4 py-3 text-foreground-600">{l.phone || '—'}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${l.status === 'active' ? 'bg-accent-100 text-accent-900' : 'bg-foreground-100 text-foreground-600'}`}>
                    {l.status === 'active' ? 'Actif' : l.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}